import React, {useRef, useState} from 'react';
import {ActionSheet, Avatar, Button, Form, ImageViewer, Input, NavBar, Toast} from "antd-mobile";
import {Await, useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {paramsToFormData} from "../../../utils/paramsToFormData";
import {LoadingContext} from "../../../components/Loading/LoadingContext";
import ApiService from "../../../utils/ApiService";
import {getExtension, getObjectURL} from "../../../utils/StringHelper";
import styles from './index.module.css';


function CollectDetail(props:any) {
  const navigate = useNavigate()
  const [search,setSearch] = useSearchParams()
  const id = search.get('id')
  const { setIsLoading } = React.useContext(LoadingContext);
  const [_,upPage]=React.useState(Math.random());

  //头像处理
  const [avatarView, setAvatarView] = useState(false)
  const [avatarAction, setAvatarAction] = useState(false)
  const uploadRef = React.useRef<any>();

  //表单处理
  const {current:tempObj} = React.useRef<any>({longPressTimer:0});
  const formObj = React.useRef<any>({address_info:'loading...'});
  let formRef = React.useRef<any>();

  React.useEffect(()=>{
    getInfo();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      //console.log("Geolocation is not supported by this browser.");
      alert('不支持定位，请更换浏览器');
    }

    function showPosition(position:any) {
      var latitude = position.coords.latitude;
      var longitude = position.coords.longitude;
      formObj.current.lonlat = longitude+','+latitude;
      lonlatToAddress(longitude,latitude);
      //console.log('position',position)
      //alert("Latitude: " + latitude + ", Longitude: " + longitude);
      //console.log("Latitude: " + latitude + ", Longitude: " + longitude);
    }


  },[])
  const lonlatToAddress = async (lon:string,lat:string)=>{
    //setIsLoading(true);
    const ret = await ApiService.getPosition(`${lon},${lat}`);
    //setIsLoading(false);
    if (ret && ret.code == 1) {
      formObj.current.address_info = ret.data.formatted_address;
    } else if (ret) {
      Toast.show(ret.message)
      formObj.current.address_info = "定位成功，地址转换失败";
    }else {
      formObj.current.address_info = "定位成功，但获取地址描述失败";
    }
    /*


    //切记在配置代理了之后一定需要添加相应的路径
    await axios.get(`http://tool.rights.st1019.cn:89/?xy=`).then(
      success => {
        if(success.status && success.data.state == 1){
          formObj.current.address_info = success.data.result.formatted_address;
        }else{
          formObj.current.address_info = "定位成功，但获取地址描述失败";
          //this.setState({isLoad:false,isError:success.data.message});
        }
      },
      error =>    {
        formObj.current.address_info = "定位成功，地址转换失败"+error.message;
        console.log(error.message);
        //this.setState({isError:'服务器繁忙，请稍后再试',isLoad:false});
      },
    )*/
    upPage(Math.random());
  }

  const getInfo = async () => {
    setIsLoading(true);
    const ret = await ApiService.getPeopleInfo(id);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      const {id,name,idcard,address,town,big_village,phone,relation_name,relation_phone,cadre_name,cadre_phone,collect_time,avatar} = ret.data;
      formObj.current = {...formObj.current,id,name,idcard,address,town,big_village,phone,relation_name,relation_phone,collect_time,cadre_name,cadre_phone,avatar};
      console.log('formObj.current', formObj.current)
      upPage(Math.random());
      //不暂停1毫秒秒不好使
      setTimeout(()=>{
        formRef.current.resetFields();
      },1)
    } else if (ret) {
      Toast.show(ret.message)

    }
  }

  const saveInfo = async (values:any)=>{
    const {lonlat,address_info} = formObj.current;
    const data = {id,lonlat,address_info,...values}
    setIsLoading(true);
    const ret = await ApiService.setPeopleInfo(data);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      Toast.show("操作成功");
    } else if (ret) {
      Toast.show(ret.message)
    }
  }

  const fileUpload = async (fileObj:any)=>{
    const file  = fileObj.target.files[0];
    const data ={
      file,
      suffix: getExtension(file.name),
      father_id: id,
      father_type: 'people',
      f_type: 'avatar',
      createby: window.localStorage.getItem('userid')||'',
      overlap: '1',
      number: '0',
    };
    setIsLoading(true);
    const ret = await ApiService.fileUpload(data);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      Toast.show("操作成功");
      formObj.current.avatar.url = getObjectURL(file);
      upPage(Math.random());
    } else if (ret) {
      Toast.show(ret.message)
    }
  }



  return (
    <div>
      <NavBar onBack={()=>navigate('/collect/list')}>{formObj.current.name}信息采集</NavBar>


      <Form ref={(val)=>{formRef.current=val}} layout='horizontal' mode='card' style={{'--prefix-width':'6em'}}
            onFinish={saveInfo}
            initialValues={formObj.current}
            footer={
              <Button block type='submit' color='primary' size='large'>
                保存采集信息
              </Button>
            }>
        <Form.Header>基础信息</Form.Header>
        <div className={styles.container}>
          <input type="file" style={{display:'none'}} ref={uploadRef} onChange={fileUpload}  accept="image/*" />
          {formObj.current.avatar?.url?
            <img src={formObj.current.avatar?.url} className={styles.avatar}
                 onTouchStart={()=> {
                   tempObj.longPressTimer = setTimeout(()=>{
                     setAvatarAction(true);
                   }, 500);
                 }}
                 onTouchEnd={()=>{
                   clearTimeout(tempObj.longPressTimer);
                 }}
                 onClick={()=>setAvatarView(true)}
            />
            :
            <img src={require('./img/upload.png')} className={styles.avatar} onClick={()=>{
              uploadRef.current?.click()
            }}
            />

          }
          <ActionSheet
            visible={avatarAction}
            cancelText='取消'
            actions={[
              { text: '更换', key: 'save',onClick:()=>{
                  setAvatarAction(false)
                  uploadRef.current?.click()
              }},
            ]}
            onClose={() => setAvatarAction(false)}
          />
          <ImageViewer
            image={formObj.current.avatar?.url}
            visible={avatarView}
            onClose={() => {
              setAvatarView(false)
            }}
          />
          <span className={styles.contextLabel}>姓名</span>{formObj.current.name}
          <br/>
          <span className={styles.contextLabel}>身份证号</span>{formObj.current.idcard}
          <br/>
          <span className={styles.contextLabel}>地址</span>{formObj.current.address}
          <br/>
          <span className={styles.contextLabel}>采集状态</span>{formObj.current.collect_time?'已采集':'未采集'}
          <br/>
          <span className={styles.contextLabel}>当前地址</span>{formObj.current.address_info}
          <br/>
        </div>
        <Form.Header>采集信息填写</Form.Header>
        <Form.Item label='本人电话' name="phone">
          <Input placeholder='请输入'/>
        </Form.Item>
        <Form.Item label='亲属姓名' name="relation_name">
          <Input placeholder='请输入'/>
        </Form.Item>
        <Form.Item label='亲属电话' name="relation_phone">
          <Input placeholder='请输入' />
        </Form.Item>
        <Form.Item label='村干部姓名' name="cadre_name">
          <Input placeholder='请输入' />
        </Form.Item>
        <Form.Item label='村干部电话' name="cadre_phone">
          <Input placeholder='请输入' />
        </Form.Item>

      </Form>
    </div>
  );
}

export default CollectDetail;
